var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewJoinees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.779 35.7484C16.8563 35.7074 14.0027 34.8539 11.5375 33.2834C9.07232 31.7129 7.09279 29.4874 5.82045 26.8559C4.5481 24.2243 4.03315 21.2907 4.33321 18.3832C4.63327 15.4756 5.73651 12.709 7.51947 10.3928C9.30242 8.07657 11.6948 6.30222 14.4287 5.26828C17.1627 4.23434 20.1305 3.9816 23 4.53834C25.8694 5.09509 28.5273 6.43935 30.6763 8.42071C32.8252 10.4021 34.3804 12.9423 35.1678 15.7572",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20H26.5M20 13.5L20 26.5",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3372 33.5638C25.9417 32.6766 26.7689 31.9475 27.7436 31.4428C28.7183 30.9382 29.8097 30.6738 30.9186 30.6738C32.0274 30.6738 33.1188 30.9382 34.0935 31.4428C35.0682 31.9475 35.8954 32.6766 36.4999 33.5638",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9183 28.0499C32.7012 28.0499 34.1465 26.3688 34.1465 24.295C34.1465 22.2212 32.7012 20.54 30.9183 20.54C29.1355 20.54 27.6902 22.2212 27.6902 24.295C27.6902 26.3688 29.1355 28.0499 30.9183 28.0499Z",
    fill: "#F8F8F8",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJoinees);
export default __webpack_public_path__ + "static/media/new-joinees.c531ac9abd27d971ff03702da341f570.svg";
export { ForwardRef as ReactComponent };